module.exports = __webpack_public_path__ + "static/media/graph-bar-and-line.3a6b2265.svg";